import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

import {searchQuery_template} from "../components/templates/searchQuery_template";


declare var ko: any;
declare var page: any;
declare var Waypoint: any;

export class searchQuery extends vnModule_knockoutJS{

    protected searchQuery_template: searchQuery_template;
    protected moduleXHRHdlSearchQueryKeywordData: XMLHttpRequestHandler;
    protected moduleXHRHdlAutoCompleteSuggestions: XMLHttpRequestHandler;
    protected moduleXHRHdlArticlesSuggestion: XMLHttpRequestHandler;
    protected XHRHdl: XMLHttpRequestHandler;

    protected optionsBulk;

    protected filterSimpleCancel(){

    }

    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "search_query";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.searchQuery_template = new searchQuery_template("searchQuery", this.viewModel, this);
        this.template = this.searchQuery_template;

        return [this.searchQuery_template.build()];
    }

    public fillPage() : void{

        this.searchQuery_template.buildDatePickerCalendars();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(){

        this.searchQuery_template.activateLoading();

        let params: Array<Array<string>> = [];
        let XHRHdl = new XMLHttpRequestHandler('/api/searchQuery/getFormData/', params, this);
        let _myThis = this;

        XHRHdl.onReadyStateFunction = _myThis.onGetListFormDataReturn;
        XHRHdl.execute();
    }

    protected onGetListFormDataReturn(req: any, obj: searchQuery) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.searchQuery_template.setFilterBrands(responseParsed.data.departments);
                obj.searchQuery_template.setFilterInitiatives(responseParsed.data.initiatives);
                obj.searchQuery_template.setFilterNetworkCategories(responseParsed.data.groupedNetworkCategories);
                obj.searchQuery_template.setFilterIntents(responseParsed.data.intents);
                obj.searchQuery_template.setFilterContentTypes(responseParsed.data.groupedContentTypes);
                obj.searchQuery_template.setViewModesItems();

                obj.updateViewModelFromPath();
                obj.getSearchQuery();
            });

            if(req.request.readyState == 4){

                obj.searchQuery_template.deactivateLoading();
            }
        };
    }

    protected getSearchQueryKeywordData(keywordPublishDate) {

        if( this.moduleXHRHdlSearchQueryKeywordData ) {
            this.moduleXHRHdlSearchQueryKeywordData.cancelAndReset();
        }

        let vm = this.searchQuery_template.getViewModelForRequest();
        vm.filter['keywordPubDate'] = keywordPublishDate;

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON( vm )] );

        this.moduleXHRHdlSearchQueryKeywordData = new XMLHttpRequestHandler('/api/searchQuery/getKeywordData', params, this);
        this.moduleXHRHdlSearchQueryKeywordData.mode = XMLHttpRequestHandler_requestType.POST;
        let localCheck = this.moduleXHRHdlSearchQueryKeywordData.requestId;
        let _myThis = this;

        setTimeout(function(){

            if( localCheck == _myThis.moduleXHRHdlSearchQueryKeywordData.requestId ){
                _myThis.moduleXHRHdlSearchQueryKeywordData.onReadyStateFunction = _myThis.getSearchQueryKeywordDataReturn;
                _myThis.moduleXHRHdlSearchQueryKeywordData.execute();
            }
        }, 400);
    }

    protected getSearchQueryKeywordDataReturn(req, obj: searchQuery){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.searchQuery_template.setSearchQueryKeywordData(responseParsed.data);
            });
        }
    }

    protected getSearchQuery(){

        this.searchQuery_template.activateLoading();

        let subViewModel = this.searchQuery_template.getViewModelForRequest();
        let baseApiUrl = '/api/searchQuery/getData';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetSearchQueryReturn, XMLHttpRequestHandler_requestType.GET, 'getSearchQuery');
    }

    protected onGetSearchQueryReturn(req, obj: searchQuery){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.searchQuery_template.resetSelectedRows();
                
                if(obj.searchQuery_template.getTemplateViewModel().viewModeSelected() == 'searchAppearance'){

                    obj.searchQuery_template.setSearchAppearancePages(responseParsed.data.data);
                }
                else {

                    obj.searchQuery_template.setSearchQuery(responseParsed.data.data);
                }
                obj.searchQuery_template.pagination.setNumberItemToPaginate(responseParsed.data.totalCount);
                obj.searchQuery_template.setSearchQueryTotals(responseParsed.totals);

                if (req.request.readyState == 4){

                    // LOADING : ends
                    obj.searchQuery_template.deactivateLoading();
                }
            });
        }
    }

    protected getAutoCompleteSuggestions(id, keyword){

        let subViewModel = {filters: {keyword: keyword}};
        let usrReq_url: string = '/api/emakiUsers/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.moduleXHRHdlAutoCompleteSuggestions = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.moduleXHRHdlAutoCompleteSuggestions.onReadyStateFunction = this.onGetAutoCompleteUsersSuggestionsReturn;
        this.moduleXHRHdlAutoCompleteSuggestions.execute();
    }

    protected onGetAutoCompleteUsersSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data){

                    obj.searchQuery_template.setFilterUsers(responseParsed.data);
                }

                if (req.request.readyState == 4){

                    // LOADING : ends
                    obj.searchQuery_template.deactivateLoading();
                }
            });
        }
    }

    protected getArticlesSuggestion(keyword){

        if(this.moduleXHRHdlArticlesSuggestion){

            this.moduleXHRHdlArticlesSuggestion.cancelAndReset();
        }

        let subViewModel = {

            filters:{

                keyword: keyword,
                brands: this.viewModel.searchQuery.brandsFilter.selectedItems(),
            }
        };

        let usrReq_url: string = '/api/emakiArticleSuggestions/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.moduleXHRHdlArticlesSuggestion = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.moduleXHRHdlArticlesSuggestion.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.moduleXHRHdlArticlesSuggestion.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj: searchQuery) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data){

                    obj.searchQuery_template.setFilterArticles(responseParsed.data);
                }
            });

            if (req.request.readyState == 4){

                // LOADING : ends
                obj.searchQuery_template.deactivateLoading();
            }
        }
    }

    protected reorder(){
        this.resetPageNumber();
        this.getSearchQuery();
    }

    protected filterMultipleSelectorOnChange(){
        this.resetPageNumber();
        this.getSearchQuery();
    }

    protected filterDateOnChange(){
        this.resetPageNumber();
        this.getSearchQuery();
    }

    // required from template [searchQuery_template]
    public filterDropdownOnChange(){
        this.togglePublishDatePicker()
        this.resetPageNumber();
        this.getSearchQuery();
    }

    // required from template [searchQuery_template]
    protected filterSimpleOnChange(){
        this.resetPageNumber();
        this.getSearchQuery();
    }

    // required from template [searchQuery_template]
    protected paginationOnPageClick(){
        this.getSearchQuery();
    }

    private resetPageNumber(){
        // go back to page 1 in the pagination
        this.viewModel.searchQuery.pagination.pageNumber(1);
    }

    private togglePublishDatePicker(): void {
        this.searchQuery_template.setEnabledPublishedDatePicker(
            this.searchQuery_template.isPublishDatesPickerEnabled()
        );
    }

    public getExportData(): void{

        this.searchQuery_template.activateLoading();

        let subViewModel = this.searchQuery_template.getViewModelForRequest();

        let usrReq_url: string = '/api/searchQuery/export/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetExportData;
        this.XHRHdl.execute();

    }

    protected onGetExportData(req, obj){

        return function () {

            let viewMode = obj.searchQuery_template.getTemplateViewModel().viewModeSelected();
            
            if(viewMode == 'searchAppearance' || viewMode == 'detailed') {
                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    if (req.request.status == 200) {

                        obj.searchQuery_template.setExportData(responseParsed.data, viewMode);
                    }
                });
                
            }

            obj.searchQuery_template.deactivateLoading();
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/searchQuery.ts